<template>
  <div class="loan-index-page">
    <router-view></router-view>
    <!-- <van-image :src="require('../../../assets/img_logo.png')" width="50" height="50" round/>
    <div>车贷在线</div> -->
    <div id="map" style="display: none;" class="map"></div>
  </div>
</template>
<script>
import { Toast, Image as VanImage } from 'vant'
import { mapActions } from 'vuex'
export default {
  name: 'loan-page',
  data() {
    return {
      loanNumber: 1,
      is_copy: this.$route.query.is_copy
    }
  },
  created() {
    this.handleInfo()
    if(this.is_copy) {
      window.localStorage.setItem('loanParams', JSON.stringify({is_copy: this.is_copy}))
    }else {
      window.localStorage.setItem('loanParams', JSON.stringify({}))
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.getLocation()
      })
    },1000)
  },
  methods: {
    ...mapActions(['fetchCommon']),
    handleInfo() {
      // 获取贷款资料信息 
      const channel_lable = window.localStorage.getItem('channel')
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.fetchCommon({
        request: 'webapi/paraminfo',
        path: 'webapi/paraminfo',
        data: {
          channel_lable: channel_lable ? channel_lable : ''
        },
        onSuccess: (res) => {
          const infoData = JSON.stringify(res.info)
          window.localStorage.setItem('infoData', infoData)
          this.checkEnter(res.data,  channel_lable)
        },
        onFail: (err) => {
          this.$toast(err.msg)
        } 
      })
    },
    checkEnter(infoData, channel_lable) {
      // 入口检查是否需要验证短信 
      let result = {}
      infoData.forEach((item, index) => result[item.lable] = item)
      window.localStorage.setItem('infoData', JSON.stringify({result, param_total: 11}))
      const yu_ao_id=this.$route.query.yu_ao_id,yu_ao=this.$route.query.yu_ao;
      if(channel_lable === 'cdol') {
        this.handleChecktoken(channel_lable, yu_ao_id, yu_ao)
      }else {
        this.$router.push(`/loan/verification?channel_lable=${channel_lable}&yu_ao_id=${yu_ao_id}&yu_ao=${yu_ao}`)
      }
    },
    handleChecktoken(channel_lable, yu_ao_id, yu_ao) {
      // 验证token是否有效
      const userToken = window.localStorage.getItem('token');
      const loanNumber = 1
      this.fetchCommon({
        request: 'webapi/checktoken',
        path: 'webapi/checktoken',
        data: {
          token: userToken
        },
        onSuccess: (res) => {
          this.$router.push('/loan/components/vocation?channel_lable='+ channel_lable+'&loanNumber='+ loanNumber)
        },
        onFail: (err) => {
          this.$router.push(`/loan/verification?channel_lable=${channel_lable}&yu_ao_id=${yu_ao_id}&yu_ao=${yu_ao}`)
        } 
      })
    },
    getLocation() {
      let map = new BMap.Map("map")
      let geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function(r){
          if(this.getStatus() == BMAP_STATUS_SUCCESS){
            var mk = new BMap.Marker(r.point);
            map.addOverlay(mk);
            map.panTo(r.point);
            // console.log(r)
            let baseInfoData = window.localStorage.getItem('baseInfoData') ? JSON.parse(window.localStorage.getItem('baseInfoData')) : {}
            baseInfoData['city_name'] = r.address.city.replace('市', '')
            baseInfoData['provcity'] = r.address.province.replace('省', '') +','+ r.address.city.replace('市', '')
            window.localStorage.setItem('baseInfoData', JSON.stringify(baseInfoData))
          }
          else {
            alert('failed'+this.getStatus());
          }        
      });
    }
  },
  // watch: {
  //   $route: {
  //     handler: function(val, oldVal){
  //       if(val !== oldVal){
  //         location.reload()
  //       }
  //     },
  //     // 深度观察监听
  //     deep: true
  //   }
  // }, 
  components: {
    [VanImage.name]: VanImage
  }
}
</script>